module.exports = __webpack_public_path__ + "static/media/bitcoin-dashboard.dc955a38.png";